/* eslint-disable no-throw-literal */
import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { updateLayoutAll } from "../components/Common";
import { withStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import CssBaseline from "@material-ui/core/CssBaseline";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import Snackbar from "@material-ui/core/Snackbar";
import DragIndicatorIcon from "@material-ui/icons/DragIndicator";
import SnackbarContent from "@material-ui/core/SnackbarContent";
import CloseIcon from "@material-ui/icons/Close";
import LinearProgress from "@material-ui/core/LinearProgress";
import Slide from "@material-ui/core/Slide";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import Designer_ToolBar from "./main_drawer/Designer_ToolBar";
import LayoutDesigner from "./layout/PaperDesigner";
import QuoteFrame from "./main_drawer/QuoteFrame";
import DocumentFrame from "./main_drawer/DocumentFrame";
import BOMFrame from "./main_drawer/BOMFrame";
import SpecificationToolDrawer from "./specification_drawer/SpecToolDrawer";
import HeaderBar from "./HeaderBar";
import { JobNotes } from "./main_drawer/JobNotes";
import JobAuditTrail from "./main_drawer/JobAuditTrail";

import { connect } from "react-redux";
import { changePage, updateDesigner } from "../redux_store/appState";
import { updateDocumentData } from "../redux_store/appStateHelper";
import {
    updateBOMData,
    updateJobParameter,
    UPDATE_QUOTE_PARAMETERS,
    updateJobState,
    getWindDataLoading,
} from "../redux_store/jobState";
import { saveJob } from "../redux_store/jobState";
import * as APP from "../redux_store/appState";
import DisplayOptions3D from "./layout/DisplayOptions3D";
import * as JOBSTATE_VALIDATION from "../redux_store/jobState_Validation";
import BSL_Dialog from "../components/BSL_Dialog";
import OrderJobPanel from "./main_drawer/OrderJobPanel";
import AreaSelector from "./specification_drawer/AreaSelector";
import LockBar from "./LockBar";
import { BSL_HelpLysaght } from "../components/BSL_HelpLysaght";
import { updateLayout2D } from "../redux_store/appStateHelper";
import { GetShapeUpdateString, GetColourUpdateString } from "./layout/PaperFunctionHelper";
import DesignerDrawingWarnings from "./DesignerDrawingWarnings";
import { formatDateLocal } from "../helper/Helper";
import NewJob from "../components_main/NewJob/NewJob";
import { styles } from "../styles/DesignerStyles";
import useDesignerHooks from "../hooks/designer/useDesignerHooks";
import BSL_DatePicker from "../components/BSL_DatePicker";
import Draggable from "react-draggable";
import { makeStyles } from "@material-ui/styles";

const importedActions = { changePage, updateDesigner, saveJob, updateBOMData, updateDocumentData };

function Designer(props) {
    const dispatch = useDispatch();
    const job = useSelector((state) => state.job);
    const app = useSelector((state) => state.app);
    const config = useSelector((state) => state.config);
    const user_data = useSelector((state) => state.app.user);
    const job_distributor = useSelector((state) => state?.job?.Distributor?.Code);

    const [open, setOpen] = React.useState(false);
    const [warningsContinue, setWarningsContinue] = React.useState(false);
    const [message, setMessage] = React.useState(false);
    const [bomOpen, setBomOpen] = React.useState(false);
    const [fast, setFast] = React.useState(false);
    const [openingQuote, setOpeningQuote] = React.useState(false);
    const [openingOrder, setOpeningOrder] = React.useState(false);
    const [warningMessages, setWarningMessages] = React.useState([]);
    const [quoteOpen, setQuoteOpen] = React.useState(false);
    const [documentOpen, setDocumentOpen] = React.useState(false);
    const [orderOpen, setOrderOpen] = React.useState(false);
    const [shouldSave, setShouldSave] = React.useState(false);
    const [engineeringStatus, setEngineeringStatus] = React.useState(null);
    const [engineeringLoading, setEngineeringLoading] = React.useState(false);
    const [isResizingEW, setIsResizingEW] = React.useState(false);
    const [isResizingNS, setIsResizingNS] = React.useState(false);
    const [openDialog, setOpenDialog] = React.useState(false);
    const [dialogData, setDialogData] = React.useState([]);
    const [triggerCustoomerFormClose, setTriggerCustoomerFormClose] = React.useState(false);
    const [newWidth, setNewWidth] = React.useState({
        width: window.innerWidth > 1400 ? 1300 : "100%",
    });
    const [newHeight, setNewHeight] = React.useState({
        height: "100%",
    });
    const [deliveryDate, setDeliveryDate] = React.useState(false);
    const [showJobNotes, setShowJobNotes] = React.useState(false);
    const [showAuditTrail, setShowAuditTrail] = React.useState(false);
    const [isFrameDocked, setIsFrameDocked] = React.useState(true);
    const [framePosition, setFramePosition] = React.useState({ x: 0, y: 0 });
    const [bomIsPopOut, setBomIsPopOut] = React.useState(() => {
        return user_data?.preferences?.bomMode === "New Window";
    });

    const SHOW_CUSTOMER_JOB_PANEL = app.designer[APP.SHOW_CUSTOMER_JOB_PANEL];
    const SHOW_DIALOG = app?.designer?.[APP.SHOW_DIALOG];
    const LOAD_WIND_DATA = app?.designer?.[APP.LOAD_WIND_DATA];
    const job_loaded = job?.id ? true : false;
    const carportMode = job?.DesignParameters?.CarportMode === 1;
    const isLysaght = window.brand === "Lysaght";
    const quoteParams =
        JSON.stringify({
            ...job?.QuoteParameters,
            ENGINEERING: null,
        }) +
        JSON.stringify(job?.SiteParameters) +
        JSON.stringify(job?.Customer) +
        job?.Status +
        job?.OrderStatus +
        job?.OverrideEngineering;

    const openMessageBox = (dialogData) => {
        setDialogData(dialogData);
        setOpenDialog(true);
    };

    let colour_change = 0;
    let shape_update = 0;
    const windowLoaded = !!window?.app;

    if (job && windowLoaded) {
        colour_change = GetColourUpdateString(true);
        shape_update = GetShapeUpdateString(true);
    }

    const openDeliveryDateDialog = () => {
        setDeliveryDate(true);
        const startStr = app.priceRise.price_rise_start_date ?? "";
        dispatch({
            type: APP.CLEAR_DESIGNER_MESSAGE,
            payload: { message: `Price Rise Planned ${startStr}. Please set estimated Delivery Date` },
        });
    };

    useDesignerHooks({
        dispatch,
        job,
        app,
        config,
        user_data,
        quoteOpen,
        carportMode,
        triggerCustoomerFormClose,
        job_distributor,
        SHOW_DIALOG,
        colour_change,
        shape_update,
        setNewWidth,
        setNewHeight,
        setDialogData,
        setOpenDialog,
        setShouldSave,
        shouldSave,
        openMessageBox,
        setTriggerCustoomerFormClose,
        quoteParams,
        openDeliveryDateDialog,
        setIsResizingEW,
        isResizingEW,
        setIsResizingNS,
        isResizingNS,
        framePosition,
        bomOpen,
        setBomIsPopOut,
    });

    const handleFrameResizeEW = (e) => {
        setIsResizingEW(true);
    };

    const handleFrameResizeNS = (e) => {
        setIsResizingNS(true);
    };

    const closeMessageBox = () => {
        setOpenDialog(false);
        dispatch(updateDesigner(APP.SHOW_DIALOG, false));
    };

    const handleClose = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }

        setOpen(false);
    };

    const overrideEngineeringAction = () => {
        let message =
            "You, " +
            app.user.DisplayName +
            " of " +
            app.user.BusinessDetails.Name +
            ", agree to TAKE RESPONSIBLITY FOR THE DESIGN OF THIS JOB outside of the engineering scope of this system.";
        setDialogData({
            title: "Authorise Engineering Override.",
            message: [<>{message}</>],
            primaryActionText: "I Authorise Override",
            primaryAction: () => {
                dispatch(updateJobParameter("OverrideEngineering", "ENG OVERRIDE APPROVED BY " + app.user.DisplayName));
            },
            secondaryActionText: "Cancel",
            secondaryAction: () => {},
        });

        setOpenDialog(true);
    };

    const continueWarningAction = ({ title, message, primaryActionText, tertiaryActionText }) => {
        return new Promise((resolve, reject) => {
            let dialog = {
                title,
                message,
                primaryActionText,
                primaryAction: () => {
                    resolve();
                },

                tertiaryActionText,
                tertiaryAction: reject(),
            };

            setDialogData(dialog);

            setOpenDialog(true);
        });
    };

    const continueEngineeringAction = ({ user, adminOnly, MaxResultsText, confirmEngineeringAction }) => {
        return new Promise((resolve, reject) => {
            let dialog = {
                title: "Engineering Not Passed",
                message: [
                    <>
                        {user.Role < 10 && adminOnly
                            ? "Please confirm engineering (a green tick) before proceeding."
                            : "Access to documents has been limited until engineering passes. Do you want to continue?"}
                        <br />
                        {MaxResultsText ? MaxResultsText : ""}
                    </>,
                ],

                primaryActionText: user.Role < 10 && adminOnly ? "Cancel" : "Continue",
                button1Id: "Continue-Engineering",
                primaryAction: () => {
                    if (user.Role < 10 && adminOnly) {
                        reject();
                    } else {
                        resolve();
                    }
                },

                tertiaryActionText: app.user.Role >= 91 ? "Authorise Override?" : "Check Engineering",
                tertiaryAction: app.user.Role >= 91 ? overrideEngineeringAction : confirmEngineeringAction,
            };

            if (!(user.Role < 10 && adminOnly)) {
                dialog = {
                    ...dialog,
                    secondaryActionText: "Cancel",
                    secondaryAction: () => {
                        reject();
                    },
                };
            }
            setDialogData(dialog);

            setOpenDialog(true);
        });
    };

    const orderEngineeringAction = () => {
        return new Promise((resolve, reject) => {
            setDialogData({
                title: "Engineering Not Passed",
                message: "Access to documents has been limited until engineering passes.",
                primaryActionText: "Cancel",
                primaryAction: () => {
                    reject();
                },
                tertiaryActionText: app.user.Role >= 91 ? "Authorise Override?" : "",
                tertiaryAction: app.user.Role >= 91 ? overrideEngineeringAction : {},
            });

            setOpenDialog(true);
        });
    };

    const confirmEngineeringAction = () => {
        dispatch(updateLayout2D(null, -1, "engineering", true));
        app.designer.designer3D.drawerToolSetExpanded = "beams_and_posts_tool";
    };

    const abortControllerRef = React.useRef(null);
    const [windDataLoading, setWindDataLoading] = React.useState(false);
    const [errorWindDataLoading, setErrorWindDataLoading] = React.useState(false);

    useEffect(() => {
        if (SHOW_CUSTOMER_JOB_PANEL || LOAD_WIND_DATA || window.loadingWindData) {
            return;
        }
        if (job?.DesignParameters?.AverageRoofHeight && !job?.SiteParameters?.WindData?.WindZoneAS1170?.critical) {
            if (abortControllerRef.current) {
                abortControllerRef.current.abort();
            }

            const abortController = new AbortController();
            abortControllerRef.current = abortController;

            let newJobState = {
                ...job,
            };

            let sent = getWindDataLoading({
                newJobState,
                setWindDataLoading,
                dispatch,
                setErrorWindDataLoading,
                abortSignal: abortController.signal,
                forceUpdate: true,
            });

            return;
        }
        if (
            job?.SiteParameters?.WindData?.WindZoneAS1170?.critical_result?.z &&
            job?.DesignParameters?.AverageRoofHeight
        ) {
            let critical_result_height = job?.SiteParameters?.WindData?.WindZoneAS1170?.critical_result?.z * 1000;
            if (
                (job?.DesignParameters?.AverageRoofHeight > 4000 &&
                    critical_result_height < job?.DesignParameters?.AverageRoofHeight - 100) ||
                (job?.DesignParameters?.AverageRoofHeight <= 4000 && critical_result_height > 4000)
            ) {
                if (abortControllerRef.current) {
                    abortControllerRef.current.abort();
                }

                const abortController = new AbortController();
                abortControllerRef.current = abortController;
                let newJobState = {
                    ...job,
                };

                let sent = getWindDataLoading({
                    newJobState,
                    setWindDataLoading,
                    dispatch,
                    setErrorWindDataLoading,
                    abortSignal: abortController.signal,
                    forceUpdate: true,
                });

                return;
            }
        }
    }, [job?.DesignParameters?.AverageRoofHeight, job?.SiteParameters?.WindData]);

    const defaultFootingChange = (props) => {};

    const defaultPostChange = (props) => {};

    DesignerDrawingWarnings({ props, warningMessages, setWarningMessages, config });

    const closeDrawers = () => {
        setOpeningQuote(false);
        setOpeningOrder(false);
        setBomOpen(false);
    };

    const toggleDock = (forceDocked) => {
        setIsFrameDocked((prev) => {
            const next = typeof forceDocked === "boolean" ? forceDocked : !prev;

            if (next === false) {
                setFramePosition({ x: 40, y: 10 });
            } else {
                setFramePosition({ x: 0, y: 0 });
            }

            return next;
        });
    };

    const toggleBomOpen = async (saved = false, forceClose = false, fast = false) => {
        let bom_was_open = bomOpen;
        let error;

        if (!fast) {
            error = await JOBSTATE_VALIDATION.validateJobOrderReadiness({
                job,
                config,
                app,
                user: app.user,
                overrideEngineeringAction,
                continueEngineeringAction,
                confirmEngineeringAction,
                forOrder: openingOrder,
                continueWarningAction,
                defaultFootingChange,
                defaultPostChange,
                bom_was_open,
                dispatch,
            });

            if (error && error.error) {
                openMessageBox(error);
                closeDrawers();
                return;
            }

            if (error.cancel) {
                closeDrawers();
                return;
            }

            if (!bom_was_open) {
                let warnings = await JOBSTATE_VALIDATION.getWarnings(job, app.user, config);

                if (warnings.errors) {
                    warnings.message.push(
                        <>
                            <br />
                            *THERE ARE ERRORS IN THIS DESIGN. PLEASE CORRECT BEFORE PROCEEDING.
                        </>
                    );
                }

                if (!warningsContinue && warnings && warnings.warning) {
                    openMessageBox({
                        ...warnings,
                        secondaryActionText: warnings.errors ? "" : "Ignore (Continue Anyway)",
                        secondaryAction: () => {
                            setWarningsContinue(true);
                            setBomOpen(!bomOpen);
                        },
                    });
                    return;
                }
            }
        }

        setBomOpen(!bomOpen);
        setFast(fast);

        if (bom_was_open) {
            if (openingQuote && saved) {
                setOpeningQuote(false);
                setQuoteOpen(!forceClose);
            } else if (openingOrder && saved) {
                setOpeningOrder(false);
                setOrderOpen(!forceClose);
            } else {
                setOpeningQuote(false);
            }
            setWarningsContinue(false);
        }
    };

    const toggleQuoteOpen = (fast = false) => {
        if (quoteOpen) {
            setQuoteOpen(false);
            setOpeningQuote(false);
        } else {
            setOpeningQuote(true);
            toggleBomOpen(false, false, fast);
            updateLayoutAll(job, app);
        }
    };

    useEffect(() => {
        if (openingOrder) {
            toggleBomOpen();
            updateLayoutAll(job, app);
        }
    }, [openingOrder]);

    const toggleOrderOpen = async () => {
        let error = await JOBSTATE_VALIDATION.validateJobOrderReadiness({
            job,
            config,
            app,
            user: app.user,
            overrideEngineeringAction,
            confirmEngineeringAction,
            continueEngineeringAction: orderEngineeringAction,
            continueWarningAction,
            defaultPostChange,
            defaultFootingChange,
            dispatch,
        });
        if (error && error.error) {
            openMessageBox(error);
            return;
        }
        if (error.cancel) {
            closeDrawers();
            return;
        }

        if (orderOpen) {
            setOrderOpen(!orderOpen);
            setOpeningOrder(false);
        } else {
            setOpeningOrder(true);
        }
    };

    const toggleGenerateQuoteAndDocumentOpen = () => {
        updateDocumentData(job, "Quote Layout");
        setDocumentOpen("Quote Layout");
        setQuoteOpen(false);
        setOpeningQuote(false);
    };

    const toggleDocumentOpen = async () => {
        let doc_was_open = documentOpen;
        let error = await JOBSTATE_VALIDATION.validateJobOrderReadiness({
            job,
            config,
            app,
            user: app.user,
            overrideEngineeringAction,
            confirmEngineeringAction,
            continueEngineeringAction,
            continueWarningAction,
            defaultPostChange,
            defaultFootingChange,
            bom_was_open: doc_was_open,
            dispatch,
        });
        if (error && error.error) {
            openMessageBox(error);
            return;
        }
        if (error.cancel) {
            closeDrawers();
            return;
        }

        if (documentOpen) {
            props.updateDesigner(APP.GENERATING_DOCUMENT, false);
            props.updateDesigner(APP.DOCUMENT_TO_SHOW, null);
        }

        setDocumentOpen(!documentOpen);
    };

    const handleStopFrameMove = (e, data) => {
        setFramePosition({ x: data.x, y: data.y });
    };

    const { classes, updateDocumentData } = props;
    const THREED_MODE = app.designer[APP.THREED_MODE];
    const THREED_MINI_MODE = app.designer[APP.THREED_MINI_MODE];
    const DOCUMENT_TO_SHOW = app.designer[APP.DOCUMENT_TO_SHOW];
    const GENERATING_DOCUMENT = app.designer[APP.GENERATING_DOCUMENT];
    const SHOW_DISPLAY_OPTIONS = app.designer[APP.SHOW_DISPLAY_OPTIONS];
    const AREA_INDEX = app.designer.designer2D?.[APP.AREA_INDEX];
    const SELECT_POINT = app.designer?.designer2D[APP.SELECT_POINT];
    const SELECT_POINT_NOTE = app.designer?.designer2D[APP.SELECT_POINT_NOTE];

    let last_job_id = "#" + job?.id;
    let job_name = job?.Customer?.FirstName;
    if (job?.Customer?.LastName) job_name += " " + job?.Customer?.LastName;
    if (!job_name) job_name = job?.Customer?.JobName;
    if (last_job_id && job_name) last_job_id = job_name + " (" + last_job_id + ")";

    const { engValidNoOverride } = JOBSTATE_VALIDATION.engineeringPassed({ job });

    return (
        <div className={classes.root}>
            <LockBar warningMessages={warningMessages} openMessageBox={openMessageBox} />
            <CssBaseline />
            <HeaderBar
                engineeringStatus={engineeringStatus}
                engineeringLoading={engineeringLoading}
                setEngineeringLoading={setEngineeringLoading}
            />
            <Designer_ToolBar
                job_loaded={job_loaded}
                toggleBomOpen={toggleBomOpen}
                toggleQuoteOpen={toggleQuoteOpen}
                toggleDocumentOpen={toggleDocumentOpen}
                toggleOrderOpen={toggleOrderOpen}
                setShowJobNotes={setShowJobNotes}
                setShowAuditTrail={setShowAuditTrail}
                isBomOpen={bomOpen}
            />
            {job_loaded && (
                <>
                    <SpecificationToolDrawer
                        openMessageBox={openMessageBox}
                        setEngineeringStatus={setEngineeringStatus}
                        setEngineeringLoading={setEngineeringLoading}
                        engineeringLoading={engineeringLoading}
                    />
                    {SELECT_POINT !== false && SELECT_POINT_NOTE && (
                        <div className={classes.selectPointNote}>
                            {AREA_INDEX > -1 && (
                                <AreaSelector
                                    multi_view={false}
                                    selectedAreaIndex={AREA_INDEX}
                                    showHeader={false}
                                    onChange={(newArea) => {
                                        dispatch(APP.update2DDesigner(APP.AREA_INDEX, newArea));
                                    }}
                                />
                            )}
                            {SELECT_POINT_NOTE}
                        </div>
                    )}
                </>
            )}

            {app.designer.SHOW_LOADING_BAR && (
                <div
                    style={{
                        position: "fixed",
                        bottom: "0px",
                        width: "100%",
                        zIndex: "1",
                    }}
                >
                    <Typography classes={{ root: classes.calculating }} variant="caption" display="block" gutterBottom>
                        Calculating...
                    </Typography>
                    <LinearProgress style={{ marginTop: "0px", height: "20px" }} color={"primary"} />
                </div>
            )}
            {job_loaded && (
                <main className={classes.content}>
                    <div className={classes.toolbar} />
                    <LayoutDesigner visible={!THREED_MODE || (THREED_MODE && THREED_MINI_MODE)} />
                </main>
            )}

            <Drawer
                key={SHOW_CUSTOMER_JOB_PANEL + LOAD_WIND_DATA}
                anchor="left"
                open={SHOW_CUSTOMER_JOB_PANEL || LOAD_WIND_DATA}
                onClose={() => setTriggerCustoomerFormClose(true)}
            >
                <BSL_HelpLysaght />
                <NewJob job={job} close={triggerCustoomerFormClose} mode="Edit" />
            </Drawer>

            <Snackbar
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                }}
                open={open}
                autoHideDuration={4000}
                onClose={handleClose}
                classes={{ root: classes.snackbar }}
            >
                <SnackbarContent
                    classes={{ root: classes.snackbar }}
                    message={message}
                    action={
                        <React.Fragment>
                            <IconButton size="small" aria-label="close" color="inherit" onClick={handleClose}>
                                <CloseIcon fontSize="small" />
                            </IconButton>
                        </React.Fragment>
                    }
                />
            </Snackbar>

            <Draggable
                handle=".drag-handle"
                position={isFrameDocked ? { x: 0, y: 0 } : framePosition}
                onStop={handleStopFrameMove}
            >
                <div
                    style={{
                        display: bomOpen ? "flex" : "none",
                        ...newWidth,
                        ...newHeight,
                        ...(bomIsPopOut ? { width: "0px" } : {}),
                    }}
                    className={classes.bom}
                >
                    {!isFrameDocked && (
                        <>
                            <div
                                className={`drag-handle ${classes.gripLeft}`}
                                style={{ backgroundColor: isLysaght ? "#3B64AB" : "#1a3061" }}
                            >
                                <DragIndicatorIcon />
                            </div>
                            <div
                                className={`drag-handle ${classes.gripRight}`}
                                style={{ backgroundColor: isLysaght ? "#3B64AB" : "#1a3061" }}
                            >
                                <DragIndicatorIcon />
                            </div>
                        </>
                    )}

                    <div onMouseDown={handleFrameResizeNS} className={classes.draggerNS} />
                    <div id="dragger" onMouseDown={handleFrameResizeEW} className={classes.draggerEW} />

                    {bomOpen && (
                        <BOMFrame
                            fast={fast}
                            isPopOut={bomIsPopOut}
                            toggleBomOpen={toggleBomOpen}
                            toggleDock={toggleDock}
                            confirmButton={
                                openingQuote ? "Confirm and Generate Quote" : openingOrder ? "Confirm and Order" : false
                            }
                            engValid={engValidNoOverride}
                        />
                    )}
                </div>
            </Draggable>

            <Slide direction="right" in={quoteOpen} mountOnEnter unmountOnExit>
                <div className={classes.bom} style={{ ...newWidth, ...newHeight }}>
                    <div
                        id="dragger"
                        onMouseDown={(event) => {
                            handleFrameResizeEW(event);
                        }}
                        className={classes.dragger}
                    />
                    <QuoteFrame
                        toggleQuoteOpen={toggleQuoteOpen}
                        toggleGenerateQuoteAndDocumentOpen={toggleGenerateQuoteAndDocumentOpen}
                    />
                </div>
            </Slide>

            <Slide direction="right" in={orderOpen} mountOnEnter unmountOnExit>
                <div className={classes.bom} style={{ ...newWidth, ...newHeight }}>
                    <div
                        id="dragger"
                        onMouseDown={(event) => {
                            handleFrameResizeEW(event);
                        }}
                        className={classes.dragger}
                    />
                    <OrderJobPanel toggleOpen={toggleOrderOpen} />
                </div>
            </Slide>

            <Slide direction="left" in={SHOW_DISPLAY_OPTIONS} mountOnEnter unmountOnExit>
                <div className={classes.display_options}>
                    <DisplayOptions3D />
                </div>
            </Slide>

            <Drawer anchor="left" open={documentOpen} onClose={() => toggleDocumentOpen()} style={{ zIndex: 9999 }}>
                <div style={DOCUMENT_TO_SHOW ? { ...newWidth, height: "100%" } : { height: "100%" }}>
                    {DOCUMENT_TO_SHOW && (
                        <div
                            id="dragger"
                            onMouseDown={(event) => {
                                handleFrameResizeEW(event);
                            }}
                            className={classes.dragger}
                        />
                    )}
                    <DocumentFrame
                        toggleDocumentOpen={toggleDocumentOpen}
                        updateDocumentData={updateDocumentData}
                        updateDesigner={props.updateDesigner}
                        DOCUMENT_TO_SHOW={DOCUMENT_TO_SHOW}
                        generatingDocument={GENERATING_DOCUMENT}
                        documentType={typeof documentOpen === "string" ? documentOpen : ""}
                    />
                </div>
            </Drawer>

            <Backdrop className={classes.backdrop} open={app.designer.SHOW_LOADING_BACKDROP}>
                {React.isValidElement(app.designer.LOADING_BACKDROP_MESSAGE) ? (
                    app.designer.LOADING_BACKDROP_MESSAGE
                ) : (
                    <>
                        <CircularProgress color="inherit" style={{ position: "absolute" }} />
                        <br />
                        <Typography variant="overline" gutterBottom style={{ marginTop: "100px" }}>
                            {app.designer.LOADING_BACKDROP_MESSAGE}...
                        </Typography>
                    </>
                )}
            </Backdrop>
            <BSL_Dialog
                title={dialogData.title}
                open={openDialog}
                onClose={() => closeMessageBox()}
                button1Id={dialogData?.button1Id}
                button1Text={dialogData?.primaryActionText ? dialogData?.primaryActionText : "OK"}
                button1Click={() => {
                    closeMessageBox();
                    if (dialogData?.primaryAction) dispatch(dialogData.primaryAction);
                }}
                button2Text={dialogData?.secondaryActionText}
                button2Click={() => {
                    closeMessageBox();
                    if (dialogData?.secondaryAction) dispatch(dialogData.secondaryAction);
                }}
                button3Text={dialogData?.tertiaryActionText}
                button3Click={() => {
                    closeMessageBox();
                    if (dialogData?.tertiaryAction) dispatch(dialogData.tertiaryAction);
                }}
            >
                {dialogData.message}
            </BSL_Dialog>
            <BSL_Dialog title={"Expected Delivery Date"} open={deliveryDate} onClose={() => setDeliveryDate(false)}>
                Price Rise Planned {app?.priceRise?.price_rise_start_date}
                <br />
                You can update the delivery date when placing the order or directly on the quote page.
                <BSL_DatePicker
                    label="Expected Delivery Date"
                    disableForwardDays={14} // 2 Weeks minimum delivery date.
                    tight
                    disabled={job?.DOrderStatus != null}
                    value={job?.QuoteParameters?.DeliveryDate}
                    onChange={(date) => {
                        // Convert date to a string in the desired format without timezone info
                        const formattedDate = formatDateLocal(date);
                        dispatch(updateJobState(UPDATE_QUOTE_PARAMETERS, "DeliveryDate", formattedDate));
                    }}
                    style={{ width: "240px", flex: "none" }}
                />
            </BSL_Dialog>
            {showJobNotes && <JobNotes toggleOpen={setShowJobNotes} />}
            {showAuditTrail && <JobAuditTrail jobId={job?.id} toggleOpen={setShowAuditTrail} />}
        </div>
    );
}

export default connect(null, importedActions)(withStyles(styles)(Designer));
